import { Component, Vue } from 'vue-property-decorator';
import _, { forEach } from "lodash";
import * as userService from "@/service/userService";
import * as util from "@/service/util";
import { MomentInput } from "moment";
import { VNode, CreateElement } from 'vue';
import { enumErrorType } from "@/views/enums/ErrorType";

@Component
export default class BaseComponent extends Vue {

  publicPath = process.env.BASE_URL;

  readonly passwordPattern = /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ `~!@#\$%\^&\*()\-_=+\[\]{}\\|;:'",<.>\/?]).*/.source;
  // readonly personNamePattern = "^[A-Za-z ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸàáạảãâầấậẩẫăằắặẳẵđèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹ]+$";
  readonly phonePattern = /^(0|(\+84))[0-9]{9,10}$/.source;
  readonly usernamePattern = /^[A-Za-z0-9_ ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸàáạảãâầấậẩẫăằắặẳẵđèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹ][^`!@#$%^&*~\{\}?]*$/.source;
  readonly fullNamePattern = /^[A-Za-z0-9_ \-\(\)ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸàáạảãâầấậẩẫăằắặẳẵđèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹ][^`"><:+!@#$%^&*~\{\}?=]{1,100}$/.source;
  //cho phép các tên dạng như ("H'Ne, Nguyễn Văn A, Nam 2, IC-HCM, IC_HCM, 123_Nam, IT012345678, nam(bình)")
  //readonly fullNamePattern = /[^`"><!@#$%^&*~\{\}?=]{1,100}$/.source;


  // readonly usernamePattern = /^[^`!@#$%^&*~\{\}?]*$/;
  readonly loadingModalId = "modal-loading";

  userId: number = userService.getCurrentUserId() || null;
  user = userService.getCurrentUser() || null;


  userCheck() {
    return this.user && (!this.user.mustChangePassword || userService.isSsoLogin());
  }


  isUserAdmin(): boolean {
    return ["Admin", "SupperAdmin"].includes(this.user?.role);
  }

  isUserSuperAdmin(): boolean {
    return this.user?.role === "SupperAdmin";
  }

  getUserManagerSaleAreaId(): number {
    if (this.isManager()) {
      return this.user.saleAreaId;
    }
  }

  isManager(): boolean {
    return this.user?.role === "Manager";
  }

  isCustomer(): boolean {
    return this.user?.role === "Customer";
  }

  isCustomerUser(): boolean {
    return this.user?.role === "User";
  }

  isViewUser(): boolean {
    return this.user?.role === "View";
  }

  getUserCustomerId(): number {
    if (this.isCustomer() || this.isCustomerUser()) {
      return this.user.customerId;
    }
  }

  isUserOrAdmin(userId: number) {
    return this.userId === userId || this.isUserAdmin();
  }

  /**
 * Hiển thị lỗi dưới dạng Toast hoặc trả về message tuỳ theo enumErrorType
 * @param error - đối tượng lỗi (exception hoặc string)
 * @param type - enumErrorType.MESSAGE để trả về chuỗi, enumErrorType.TOAST để hiển thị toast
 */
  showError(e, type) {
    let translatedMsg = this.$t("khongxacdinh");

    try {
      const data = e?.response?.data || {};
      const code = data.code || e?.code;
      const message = typeof data.message === "string" ? data.message : data.message?.value;

      translatedMsg = this.$te(code) ? this.$t(code) : message ?? this.$t("khongxacdinh");
    } catch (err) {
      console.error(err);
    }

    if (type === enumErrorType.MESSAGE) return translatedMsg.toString();

    this.$bvToast.toast(translatedMsg.toString(), {
      toaster: "b-toaster-bottom-right",
      title: "Error",
      autoHideDelay: 7500,
      variant: "danger",
      headerClass: "bg-danger text-white"
    });
  }

  toastErrorOldType(e) {
    // const message = e.response?.data?.message || e.message;
    // this.$bvToast.toast(message, {
    //   toaster: "b-toaster-bottom-right",
    //   title: "Error",
    //   autoHideDelay: 7500,
    //   variant: "danger",
    //   headerClass: "bg-danger text-white"
    // });
    this.showError(e, enumErrorType.TOAST);
  }

  toastError(e) {
    // const message = e.response?.data?.code || e.code;
    // this.$bvToast.toast(this.$t(message).toString(), {
    //   toaster: "b-toaster-bottom-right",
    //   title: "Error",
    //   autoHideDelay: 7500,
    //   variant: "danger",
    //   headerClass: "bg-danger text-white"
    // });
    this.showError(e, enumErrorType.TOAST);
  }

  toastErrorMessage(message) {
    this.$bvToast.toast(message, {
      toaster: "b-toaster-bottom-right",
      title: "Error",
      autoHideDelay: 7500,
      variant: "danger",
      headerClass: "bg-danger text-white"
    });
  }

  ErrorWithList(e) {
    const message = e.response?.data?.message;

    const node = this.$createElement('div',
      message.map((m) => {
        return this.$createElement('p', this.$t("errorRow", { row: m.row, value: m.value }).toString());
      })
    );
    // this.$bvToast.toast(node, {
    //   toaster: "b-toaster-bottom-right",
    //   title: "Error",
    //   autoHideDelay: 7500,
    //   variant: "danger",
    //   headerClass: "bg-danger text-white"
    // });
    return message.map((m) => { return this.$t("errorRow", { row: m.row, value: m.value }).toString(); });
  }

  toastSuccess(title: string, message: string) {
    return this.$bvToast.toast(message, {
      toaster: "b-toaster-bottom-right",
      title,
      autoHideDelay: 7500,
      variant: "success",
      headerClass: "bg-success text-white"
    });
  }

  toastSuccessDelay(message: string, title?: string, delay?: number) {
    title = title || this.$t("alert").toString();
    if (_.isNil(delay)) delay = 300;

    return setTimeout(() => this.toastSuccess(title, message), delay);
  }

  showLoading() {
    this.$bvModal.show(this.loadingModalId);
  }

  hideLoading() {
    this.$bvModal.hide(this.loadingModalId);
  }

  localDateTimeFormat(value: MomentInput) {
    return util.localDateTimeFormat(value);
  }

  localDateTimeFormatWB(value: MomentInput) {
    return util.formatWbDateTime(value);
  }

  localDateFormat(value: MomentInput) {
    return util.localDateFormat(value);
  }

  localTimeFormat(value: MomentInput) {
    return util.localTimeFormat(value);
  }

  formatCurrencyAmount(value: number) {
    return util.formatCurrencyAmount(value);
  }

  formatUrl(value: string) {
    const domain = this.getURLsFromLocation();
    const startIndex = value.indexOf('/app');
    value = value.substring(startIndex);
    if (value.charAt(0) === '/') {
      value = value.substring(1);
    }
    return domain + value;
  }

  getURLsFromLocation() {
    try {
      const currentURL = new URL(window.location.href);

      // Tạo URL với http
      const httpURL = new URL(`http://${currentURL.host}`);

      // Tạo URL với https
      const httpsURL = new URL(`https://${currentURL.host}`);

      // Kiểm tra xem http có hỗ trợ không
      if (currentURL.protocol === "http:") {
        return httpURL.href; // Trả về URL hiện tại nếu là http
      } else {
        // Trả về URL với https nếu không phải là http
        return httpsURL.href;
      }
    } catch (error) {
      console.error(`Không thể tạo URL từ window.location: ${error}`);
      return null;
    }
  }
  /// Hàm get ngày nhỏ nhất
  getMinDate(startDate) {
    return startDate ?? new Date();
  }

  ///Hàm get ngày lớn nhất
  getMaxDate() {
    const now = new Date();
    return now.setDate(now.getDate() + 30).toString();
  }

  //Hàm bắt lỗi dạng message or message[]
  returnErrorMessage(e) {
    const data = e.response?.data;
    //fallbackMessage: trường hợp messages là 1 string, không thì nhận giá trị của message.value
    const fallbackMessage = typeof data?.message === 'string' ? data.message : data?.message?.value;
    // Kiểm tra xem có tồn tại key code trong file đa ngôn ngữ không không thì hiển thị fallbackMessage, không bắt được fallbackMessage hiển thị không xác định
    const translatedMsg = this.$te(data?.code) ? this.$t(data?.code) : fallbackMessage ?? this.$t("khongxacdinh");
    const msgString = translatedMsg.toString();
    return msgString.replace(/\(\d+\/\d+[^)]*\)/g, "<strong>$&</strong>");
  }

  showStartMeetingError(e) {
    const warningModal = this.$refs.startMeetingWarningModal as any;
    if (warningModal) {
      warningModal.show(e);
    }
  }

  handleStartMeetingError(e) {
    this.showStartMeetingError(e);
    this.hideLoading();
  }

  isActiveFeatures(features) {
    return (features ?? [])
      .filter(f => f.isActive)
      .sort((a, b) => a.featureId - b.featureId);
  }
  sortedFeatures(featureList) {
    return [...(featureList ?? [])].sort((a, b) => a.featureId - b.featureId);
  }
}
